const BASE_URL = process.env.REACT_APP_BACKEND_URL_PROD;
const BASE_URL_DEV = process.env.REACT_APP_BACKEND_URL;
const BASE_URL_MAIN_DEV = process.env.REACT_APP_BASE_URL_MAIN;
const BASE_URL_MAIN_PROD = process.env.REACT_APP_BACKEND_URL_MAIN_PROD;
const JUDGE_URL = process.env.REACT_APP_JUDGE_URL;
const JUDGE_URLTWO = process.env.REACT_APP_JUDGE_URLTWO;

const isDev = localStorage.getItem('isDev') === 'true';
const MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE = isDev ? BASE_URL_MAIN_DEV : BASE_URL_MAIN_PROD;

export const authEndpoints = {
  LOGIN_IN: BASE_URL + '/auth/login',
  LOGOUT_IN: BASE_URL + '/auth/logout',
  SET_USER_IN: BASE_URL + '/auth/addUser',
  CHECK_IF_PREMIUM: BASE_URL + '/auth/checkIfEmailIsPremium',
  DOWNLOAD_INOVICE: BASE_URL + '/auth/downloadInvoice',
  CHANGE_EMAIL: BASE_URL + '/auth/changeEmail',
  SET_USER_IN_DEV: BASE_URL_DEV + '/auth/addUser',
  ALL_USERS: BASE_URL + '/profile/getAllUsers/',
  ALL_PRIVELEGEDUSERS_USERS: BASE_URL + '/profile/getAllPrivilegedUsers',
  DELETE_USER: BASE_URL + '/profile/deleteUser/',
  DELETE_USER_DEV: BASE_URL_DEV + '/profile/deleteUser/',
};

export const categoriesEndpoints = {
  GET_ALL_CAT: BASE_URL + '/categories/getAllCategories',
  ADD_CAT: BASE_URL + '/categories/addCategory',
  UPDATE_CAT: BASE_URL + '/categories/editCategory/',
  DEL_CAT: BASE_URL + '/categories/deleteCategory/',
};
export const subCategoriesEndpoints = {
  GET_ALL_SUB_CAT: BASE_URL + '/subCategories/getCategoriesWithSubcategories',
  ADD_SUB_CAT: BASE_URL + '/subCategories/addSubcategory',
  UPDATE_SUB_CAT: BASE_URL + '/subCategories/editSubcategory/',
  DEL_SUB_CAT: BASE_URL + '/subCategories/deleteSubcategory/',
};

export const categoriesEndpointsDev = {
  GET_ALL_CAT_DEV: BASE_URL_DEV + '/categories/getAllCategories',
  ADD_CAT_DEV: BASE_URL_DEV + '/categories/addCategory',
  UPDATE_CAT_DEV: BASE_URL_DEV + '/categories/editCategory/',
  DEL_CAT_DEV: BASE_URL_DEV + '/categories/deleteCategory/',
};
export const subCategoriesEndpointsDev = {
  GET_ALL_SUB_CAT_DEV: BASE_URL_DEV + '/subCategories/getCategoriesWithSubcategories',
  ADD_SUB_CAT_DEV: BASE_URL_DEV + '/subCategories/addSubcategory',
  UPDATE_SUB_CAT_DEV: BASE_URL_DEV + '/subCategories/editSubcategory/',
  DEL_SUB_CAT_DEV: BASE_URL_DEV + '/subCategories/deleteSubcategory/',
};
export const problemsEndpoints = {
  GET_ALL_PROBLEM: BASE_URL + '/problems/getAllProblems',
  GET_DISLIKED_PROBLEMS: BASE_URL + '/problems/getDislikedProblems',
  ADD_PROBLEM: BASE_URL + '/problems/addProblem',
  UPDATE_PROBLEM: BASE_URL + '/problems/editProblem/',
  DEL_PROBLEM: BASE_URL + '/problems/deleteProblem/',
  ADD_PROBLEM_VIDEO_THUMB: BASE_URL + '/problems/addVideosToProblem',
  ADD_PROBLEM_EDITORIALS: BASE_URL + '/problems/addEditorialsToProblem',
  GET_PROBLEM: BASE_URL + '/problems/getSingleProblem/',
  GET_DELETED_PROBLEM: BASE_URL + '/problems/getDeletedProblems',
  ADD_DELETED_PROBLEM: BASE_URL + '/problems/addDeletedProblem/',
  DEL_DELETED_PROBLEM: BASE_URL + '/problems/deleteDeletedProblem/',
};
export const problemsEndpointsDev = {
  GET_ALL_PROBLEM_DEV: BASE_URL_DEV + '/problems/getAllProblems',
  GET_DISLIKED_PROBLEMS_DEV: BASE_URL_DEV + '/problems/getDislikedProblems',
  ADD_PROBLEM_DEV: BASE_URL_DEV + '/problems/addProblem',
  UPDATE_PROBLEM_DEV: BASE_URL_DEV + '/problems/editProblem/',
  DEL_PROBLEM_DEV: BASE_URL_DEV + '/problems/deleteProblem/',
  ADD_PROBLEM_VIDEO_THUMB_DEV: BASE_URL_DEV + '/problems/addVideosToProblem',
  ADD_PROBLEM_EDITORIALS_DEV: BASE_URL_DEV + '/problems/addEditorialsToProblem',
  GET_PROBLEM_DEV: BASE_URL_DEV + '/problems/getSingleProblem/',
  GET_DELETED_PROBLEM_DEV: BASE_URL_DEV + '/problems/getDeletedProblems',
  ADD_DELETED_PROBLEM_DEV: BASE_URL_DEV + '/problems/addDeletedProblem/',
  DEL_DELETED_PROBLEM_DEV: BASE_URL_DEV + '/problems/deleteDeletedProblem/',
};
export const problemSetterEndpointsDev = {
  GET_PROBLEM_DETAILS_DEV: BASE_URL_DEV + '/problemSetter/problemDetails/',
  UPDATE_PROBLEM_SETTER_DATA_DEV: BASE_URL_DEV + '/problemSetter/editProblem',
};
export const problemSetterEndpoints = {
  GET_PROBLEM_DETAILS: BASE_URL + '/problemSetter/problemDetails/',
  UPDATE_PROBLEM_SETTER_DATA: BASE_URL + '/problemSetter/editProblem',
};
export const sessionsEndpoints = {
  GET_SESSIONS: BASE_URL + '/sessions/getAllSessions',
  ADD_SESSION: BASE_URL + '/sessions/createSession',
  UPDATE_SESSION: BASE_URL + '/sessions/updateSession/',
  DEL_SESSION: BASE_URL + '/sessions/deleteSession/',
  GET_SESSION: BASE_URL + '/sessions/getSession/',
  ADD_SESSION_DEV: BASE_URL_DEV + '/sessions/createSession',
  UPDATE_SESSION_DEV: BASE_URL_DEV + '/sessions/updateSession/',
  GET_SESSION_DEV: BASE_URL_DEV + '/sessions/getSession/',
  DEL_SESSION_DEV: BASE_URL_DEV + '/sessions/deleteSession/',
};
export const notificationEndpoints = {
  ADD_NOTIFICATION: BASE_URL + '/notifications/addNotification',
  UPDATE_NOTIFICATION: BASE_URL + '/notifications/updateNotification/',
  GET_NOTIFICATIONS: BASE_URL + '/notifications/showAllNotifications',
  DEL_NOTIFICATION: BASE_URL + '/notifications/deleteNotification/',
  SEND_EMAIL_TO_PREMIUM_USERS: BASE_URL + '/notifications/sendEmailsToPremiumUsers',
  ADD_PLUS_UPDATE: BASE_URL_DEV + '/notifications/add-plusUpdate',
  ADD_PLUS_UPDATE_PROD: BASE_URL + '/notifications/add-plusUpdate',
  EDIT_PLUS_UPDATE: BASE_URL_DEV + '/notifications/edit-plusUpdate/',
  EDIT_PLUS_UPDATE_PROD: BASE_URL + '/notifications/edit-plusUpdate/',
  REMOVE_PLUS_UPDATE: BASE_URL_DEV + '/notifications/delete-plusUpdate/',
  GET_ALL_PLUS_UPDATES: BASE_URL_DEV + '/notifications/getAllPlusUpdates',
};
export const referralEndpoints = {
  GET_AFFILIATE_SALES: BASE_URL + '/affiliates/affiliate-sales',
  GENERATE_SHEET: BASE_URL + '/affiliates/generate-payment-sheet',
  DEACTIVATE_REFERRAL_CODE: BASE_URL + '/affiliates/deactivate-coupon',
  REACTIVATE_REFERRAL_CODE: BASE_URL + '/affiliates/reactivate-coupon',
};
export const bugReportsEndpoints = {
  GET_REPORTED_BUGS: BASE_URL + '/bugs/reported-bugs/',
  MARK_STATUS: BASE_URL + '/bugs/bug-status',
  GET_ALL_BUGS: BASE_URL + '/bugs/get-all-reported-bugs',
  SEND_EMAIL: BASE_URL + '/bugs/send-email',
  GET_BUG_BY_ID: BASE_URL + '/bugs/get-bug',
};
export const grantAccessEndpoints = {
  ADD_USER: BASE_URL + '/access/addUser',
  ADD_USER_DEV: BASE_URL_DEV + '/access/addUser',
  GRANT_USER_ACCESS: BASE_URL + '/access/grantUserAccess',
  EDIT_USER: BASE_URL + '/access/updateUser',
  DELETE_USER: BASE_URL + '/access/deleteUser/',
  GET_ALL_USERS: BASE_URL + '/access/getAllUsers',
  REMOVE_PREMIUM_ACCESS: BASE_URL + '/access/removePremiumAccess',
};
export const salesTrackerEndpoints = {
  GET_TOTAL_SALES: BASE_URL + '/revenue/total-sales/',
  GET_STATEWISE_SALES: BASE_URL + '/revenue/sales-in-state',
};
export const commentsEndpoints = {
  GET_DOUBT_COST_DAYWISE: BASE_URL + '/comments/doubt-cost',
  GET_DISCUSSIONS: BASE_URL + '/comments/discussions',
  DEL_DISCUSSION: BASE_URL + '/comments/discussions/delete',
};
export const judgeStatsEndpoints = {
  GET_JUDGE_STATS: BASE_URL + '/judgeStats/judge-stats',
  GET_JUDGE_PERFORMANCE_STATS : BASE_URL + '/judgeStats/judge-stats/performance'
};

export const configEndpoints = {
  ADD_CONFIG: BASE_URL + '/configs/addConfigValue',
  EDIT_CONFIG: BASE_URL + '/configs/updateConfig/',
  GET_ALL_CONFIG: BASE_URL + '/configs/getConfigDetails',
  DELETE_CONFIG: BASE_URL + '/configs/deleteConfig/',
};
export const clearCacheEndpoints = {
  CLEAR_CACHE: BASE_URL + '/problems/clearCache',
  CLEAR_CACHE_JUDGE: JUDGE_URL + '/cacheClearJudge',
  CLEAR_CACHE_JUDGETWO: JUDGE_URLTWO + '/cacheClearJudge',
};
export const premiumEndpoints = {
  ADD_PLAN: BASE_URL + '/premium/add-plan',
  EDIT_PLAN: BASE_URL + '/premium/edit-plan',
  DELETE_PLAN: BASE_URL + '/premium/delete-plan',
  GET_ALL_PLANS: BASE_URL + '/premium/all-plans',

  GET_ALL_COUPON_CODES: BASE_URL + '/premium/all-coupons',
  ADD_COUPON_CODE: BASE_URL + '/premium/add-coupon',
  EDIT_COUPON_CODE: BASE_URL + '/premium/edit-coupon',
  DELETE_COUPON_CODE: BASE_URL + '/premium/delete-coupon',

  GET_WHITELIST_EMAILS: BASE_URL + '/premium/all-whitelist-emails',
  ADD_WHITELIST_EMAIL: BASE_URL + '/premium/add-whitelist-email',
  DELETE_WHITELIST_EMAIL: BASE_URL + '/premium/delete-whitelist-email',

  GENERATE_EMI_TOKEN: BASE_URL + '/emipayments/generate-emi-token',
  GRANT_EMI_ACCESS: BASE_URL + '/emipayments/grant-emi-access',
  EMI_USER_STATUS: BASE_URL + '/emipayments/emi-user-status',
  GET_ALL_EMI_USERS: BASE_URL + '/emipayments/all-emi-users',
};
export const userStatsEndpoints = {
  GET_SUBMISSION_STATS: BASE_URL + '/userStats/submission-stats',
  GET_AI_DOUBT_STATS: BASE_URL + '/userStats/doubt-stats',
  GET_ACTIVE_USERS_STATS: BASE_URL + '/userStats/active-user-stats',
  GET_USERS_PROGRESS_STATS: BASE_URL + '/userStats/user-progress-stats',
  GET_AVERAGE_RATING: BASE_URL + '/userStats/feedback-stats',
  GET_RECENT_RATINGS: BASE_URL + '/userStats/feedback-recent/',
  DELETE_FEEDBACK: BASE_URL + '/userStats/delete-feedback',
};
export const successStoriesEndpoints = {
  GET_PENDING_STORIES: BASE_URL + '/stories/pending',
  GET_APPROVED_STORIES: BASE_URL + '/stories/approved',
  GET_DISAPPROVED_STORIES: BASE_URL + '/stories/disapproved',
  UPDATE_STATUS: BASE_URL + '/stories/update-status',
  ADD_STORY: BASE_URL + '/stories/add-story',
};


export const interviewExperienceEndpoints = {
  SUBMIT_INTERVIEW_EXPERIENCE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/submit-interviewExperince',
  DELETE_INTERVIEW_EXPERIENCE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/delete-interview-experience/',
  GET_INTERVIEW_EXPERIENCE_BY_ID: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/get-interview-experience/',
  TOGGLE_ISAPPROVED_INTERVIEW_EXPERIENCE : MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/approve-interview-exp/',

  GET_ALL_INTERVIEW_EXPERIENCES: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/get-all-interview-experiences/',
  GET_ALL_DRAFT_INTERVIEW_EXPERIENCES: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/get-all-draft',
  GET_SINGLE_DRAFT_INTERVIEW_EXPERIENCE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/get-single-draft/',
  DELETE_DRAFT_INTERVIEW_EXPERIENCE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/delete-draft/',
  UPDATE_INTERVIEW_EXPERIENCE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/update-interview-experience/',
  ADD_COMMENTS_MESSAGE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/add-comments/',
  GET_COMMENTS_MESSAGE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/get-comments/',
  UPDATE_INTERVIEW_EXPERIENCE_STATUS: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/update-draft-status/',
  UPDATE_DRAFT_INTERVIEW_EXPERIENCE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/update-draft/',
  
  UPVOTE_INTERVIEW_EXPERIENCE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/upvote-post/',
  GET_MY_INTERVIEW_EXPERIENCE: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/myInterviewExperinces',
  GET_UPVOTES_BY_TIME: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/byTime',
  GET_UPVOTES_BY_UPVOTES: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/byUpvotes',

  MOVE_TO_PUBLISHED: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/move-to-published/',

  SUBMIT_INTERVIEW_EXPERIENCE_PROD: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/submit-interviewExperince',
  DELETE_INTERVIEW_EXPERIENCE_PROD: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/delete-experience',
  GET_INTERVIEW_EXPERIENCE_BY_ID_PROD: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/experience-details/',

  GET_ALL_INTERVIEW_EXPERIENCES_PROD: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/interviewExperience/get-all-interview-experiences',
  
  UPVOTE_INTERVIEW_EXPERIENCE_PROD: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/upvote-post/',
  GET_MY_INTERVIEW_EXPERIENCE_PROD: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/myInterviewExperinces',
  GET_UPVOTES_BY_TIME_PROD: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/byTime',
  GET_UPVOTES_BY_UPVOTES_PROD: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/v2/interviewExperience/byUpvotes',
};

export const companiesEndpoints = {
  GET_ALL_COMPANIES: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/company/get-all-companies/',
  ADD_COMPANY: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/company/add-company/',
  UPDATE_COMPANY: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/company/update-company/',
  DELETE_COMPANY: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/company/delete-company/',
  GET_COMPANY_BY_ID: MAIN_BACKEND_URL_FOR_INTERVIEW_EXPERIENCE + '/company/getCompanyById/',
}

export const Errors = {
  GET_ERRORS: BASE_URL + '/errors?',
}

export const DSA = {
  GET_ALL_DSA_PROBLEMS: BASE_URL_DEV + '/v2/problems/getAllDSAProblems',
  GET_SINGLE_DSA_PROBLEMS: BASE_URL_DEV + '/v2/problems/getSingleDSAProblem/',
  ADD_DSA_PROBLEM: BASE_URL_DEV + '/v2/problems/addDSAProblem',
  UPDATE_DSA_PROBLEM: BASE_URL_DEV + '/v2/problems/editDSAProblem/',
  DELETE_DSA_PROBLEM: BASE_URL_DEV + '/v2/problems/deleteDSAProblem/',
  GET_COPY_TO_EDITOR: BASE_URL_DEV + '/v2/problems/generateCopyToEditorCode/',
};

export const THEORY = {
  GET_ALL_THEORY_PROBLEMS: BASE_URL_DEV + '/v2/problems/getAllTheoryProblems',
  GET_SINGLE_THEORY_PROBLEMS: BASE_URL_DEV + '/v2/problems/getSingleTheoryProblem/',
  ADD_THEORY_PROBLEM: BASE_URL_DEV + '/v2/problems/addTheoryProblem',
  UPDATE_THEORY_PROBLEM: BASE_URL_DEV + '/v2/problems/editTheoryProblem/',
  DELETE_THEORY_PROBLEM: BASE_URL_DEV + '/v2/problems/deleteTheoryProblem/',
};

export const QUIZ = {
  GET_ALL_QUIZ_PROBLEMS: BASE_URL_DEV + '/v2/problems/getAllQuizProblems',
  GET_SINGLE_QUIZ_PROBLEMS: BASE_URL_DEV + '/v2/problems/getSingleQuizProblem/',
  ADD_QUIZ_PROBLEM: BASE_URL_DEV + '/v2/problems/addQuizProblem',
  UPDATE_QUIZ_PROBLEM: BASE_URL_DEV + '/v2/problems/editQuizProblem/',
  DELETE_QUIZ_PROBLEM: BASE_URL_DEV + '/v2/problems/deleteQuizProblem/',
};

export const APTITUDE = {
  GET_ALL_APTITUDE_PROBLEMS: BASE_URL_DEV + '/v2/problems/getAllAptitudeProblems',
  GET_SINGLE_APTITUDE_PROBLEMS: BASE_URL_DEV + '/v2/problems/getSingleAptitudeProblem/',
  ADD_APTITUDE_PROBLEM: BASE_URL_DEV + '/v2/problems/addAptitudeProblem',
  UPDATE_APTITUDE_PROBLEM: BASE_URL_DEV + '/v2/problems/editAptitudeProblem/',
  DELETE_APTITUDE_PROBLEM: BASE_URL_DEV + '/v2/problems/deleteAptitudeProblem/',
  UPDATE_APTITUDE_PROBLEM_PROD: BASE_URL + '/v2/problems/editAptitudeProblem/',
  DELETE_APTITUDE_PROBLEM_PROD: BASE_URL + '/v2/problems/deleteAptitudeProblem/',
  ADD_APTITUDE_PROBLEM_PROD: BASE_URL + '/v2/problems/addAptitudeProblem',
}

export const TOPICS = {
  GET_ALL_CATEGORIES_V2: BASE_URL_DEV + '/v2/problems/getAllCategories',
  ADD_CATEGORY_V2: BASE_URL_DEV + '/v2/problems/addCategory',
  UPDATE_CATEGORY_V2: BASE_URL_DEV + '/v2/problems/editCategory/',
  DELETE_CATEGORY_V2: BASE_URL_DEV + '/v2/problems/deleteCategory/',

  GET_ALL_SUB_CATEGORIES_V2: BASE_URL_DEV + '/v2/problems/getAllSubCategories',
  ADD_SUB_CATEGORY_V2: BASE_URL_DEV + '/v2/problems/addSubCategory',
  UPDATE_SUB_CATEGORY_V2: BASE_URL_DEV + '/v2/problems/editSubCategory/',
  DELETE_SUB_CATEGORY_V2: BASE_URL_DEV + '/v2/problems/deleteSubCategory/',

  GET_ALL_TOPICS_V2: BASE_URL_DEV + '/v2/problems/getAllTopics',
  ADD_TOPIC_V2: BASE_URL_DEV + '/v2/problems/addTopic',
  UPDATE_TOPIC_V2: BASE_URL_DEV + '/v2/problems/editTopic/',
  DELETE_TOPIC_V2: BASE_URL_DEV + '/v2/problems/deleteTopic/',
  REMOVE_PROBLEM_FROM_ORDER: BASE_URL_DEV + '/v2/problems/removeProblemFromOrder/',
}

export const SUBJECT_ORDER = {
  GET_ALL_SUBJECT_PROBLEMS: BASE_URL_DEV + '/v2/problems/getAllSubjectProblems/',

  SET_PROBLEM_ORDER: BASE_URL_DEV + '/v2/problems/setProblemOrder/',

  SET_SUB_CATEGORY_PROBLEM_ORDER: BASE_URL_DEV + '/v2/problems/setSubCategoryProblemOrder/',

  SET_CATEGORY_PROBLEM_ORDER: BASE_URL_DEV + '/v2/problems/setCategoryProblemOrder/',
};


export const manageCoursesEndpoints = {

  // add courses
  ADD_MY_COURSE: BASE_URL_DEV + '/v2/problems/addMyCourse',
  ADD_PARTNERS_COURSE: BASE_URL_DEV + '/v2/problems/addPartnerCourse',

  // get courses
  GET_ALL_MY_COURSES: BASE_URL_DEV + '/v2/problems/getAllMyCourses',
  GET_ALL_PARTNERS_COURSES: BASE_URL_DEV + '/v2/problems/getAllPartnerCourses',

  // update courses
  UPDATE_PARTNERS_COURSE: BASE_URL_DEV + '/v2/problems/updatePartnerCourse/',
  UPDATE_MY_COURSE: BASE_URL_DEV + '/v2/problems/updateMyCourse/',

  // delete courses
  DELETE_MY_COURSE: BASE_URL_DEV + '/v2/problems/deleteMyCourse/',
  DELETE_PARTNERS_COURSE: BASE_URL_DEV + '/v2/problems/deletePartnerCourse/',
}

export const DSA_PROD = {
  ADD_DSA_PROBLEM_PROD: BASE_URL + '/v2/problems/addDSAProblem',
  UPDATE_DSA_PROBLEM_PROD: BASE_URL + '/v2/problems/editDSAProblem/',
  DELETE_DSA_PROBLEM_PROD: BASE_URL + '/v2/problems/deleteDSAProblem/',
};

export const THEORY_PROD = {
  ADD_THEORY_PROBLEM_PROD: BASE_URL + '/v2/problems/addTheoryProblem',
  UPDATE_THEORY_PROBLEM_PROD: BASE_URL + '/v2/problems/editTheoryProblem/',
  DELETE_THEORY_PROBLEM_PROD: BASE_URL + '/v2/problems/deleteTheoryProblem/',
};

export const QUIZ_PROD = {
  ADD_QUIZ_PROBLEM_PROD: BASE_URL + '/v2/problems/addQuizProblem',
  UPDATE_QUIZ_PROBLEM_PROD: BASE_URL + '/v2/problems/editQuizProblem/',
  DELETE_QUIZ_PROBLEM_PROD: BASE_URL + '/v2/problems/deleteQuizProblem/',
};

export const TOPICS_PROD = {
  ADD_CATEGORY_V2_PROD: BASE_URL + '/v2/problems/addCategory',
  UPDATE_CATEGORY_V2_PROD: BASE_URL + '/v2/problems/editCategory/',
  DELETE_CATEGORY_V2_PROD: BASE_URL + '/v2/problems/deleteCategory/',

  ADD_SUB_CATEGORY_V2_PROD: BASE_URL + '/v2/problems/addSubCategory',
  UPDATE_SUB_CATEGORY_V2_PROD: BASE_URL + '/v2/problems/editSubCategory/',
  DELETE_SUB_CATEGORY_V2_PROD: BASE_URL + '/v2/problems/deleteSubCategory/',

  ADD_TOPIC_V2_PROD: BASE_URL + '/v2/problems/addTopic',
  UPDATE_TOPIC_V2_PROD: BASE_URL + '/v2/problems/editTopic/',
  DELETE_TOPIC_V2_PROD: BASE_URL + '/v2/problems/deleteTopic/',
  REMOVE_PROBLEM_FROM_ORDER_PROD: BASE_URL + '/v2/problems/removeProblemFromOrder/',
};

export const SUBJECT_ORDER_PROD = {
  SET_PROBLEM_ORDER_PROD: BASE_URL + '/v2/problems/setProblemOrder/',
  SET_SUB_CATEGORY_PROBLEM_ORDER_PROD: BASE_URL + '/v2/problems/setSubCategoryProblemOrder/',
  SET_CATEGORY_PROBLEM_ORDER_PROD: BASE_URL + '/v2/problems/setCategoryProblemOrder/',
};

export const manageCoursesEndpoints_PROD = {
  // add courses
  ADD_MY_COURSE_PROD: BASE_URL + '/v2/problems/addMyCourse',
  ADD_PARTNERS_COURSE_PROD: BASE_URL + '/v2/problems/addPartnerCourse',

  // update courses
  UPDATE_PARTNERS_COURSE_PROD: BASE_URL + '/v2/problems/updatePartnerCourse/',
  UPDATE_MY_COURSE_PROD: BASE_URL + '/v2/problems/updateMyCourse/',

  // delete courses
  DELETE_MY_COURSE_PROD: BASE_URL + '/v2/problems/deleteMyCourse/',
  DELETE_PARTNERS_COURSE_PROD: BASE_URL + '/v2/problems/deletePartnerCourse/',
};


export const salesDashboardEndpoints = {
  // Failed Users
  GET_FAILED_USERS: BASE_URL + '/sales/failed-users',
  GET_FAILED_USER_DETAILS: BASE_URL + '/sales/failed-user-details',

  // Dropped Users
  GET_DROPPED_USERS: BASE_URL + '/sales/dropped-users',
  GET_DROPPED_USER_DETAILS: BASE_URL + '/sales/dropped-user-details',

  // Call Status
  UPDATE_CALL_STATUS: BASE_URL + '/sales/call-status',
  // Add Coupon
  ADD_COUPON_CODE: BASE_URL + '/sales/add-coupon',
  // Call Details
  ADD_CALL_DETAILS: BASE_URL + '/sales/call-details',
  // Find User
  FIND_USER_BY_EMAIL: BASE_URL + '/sales/find-user',

  GET_ALL_WHATSAPP_USERS:  BASE_URL + '/sales/whatsapp-users',
  GET_WHATSAPP_USER_DETAILS:  BASE_URL + '/sales/whatsapp-user-details',
  ADD_WHATSAPP_USER:  BASE_URL + '/sales/add-whatsapp-user',
  UPDATE_BUYING_STATUS:  BASE_URL + '/sales/buying-status',
  ADD_WHATSAPP_USER_DETAILS:  BASE_URL + '/sales/add-details',
  UPDATE_WHATSAPP_USER_DETAILS: BASE_URL + '/sales/edit-whatsapp-user',

  GET_COUNT : BASE_URL + '/sales/get-user-count',
  GET_COUNT_DAILY : BASE_URL + '/sales/get-user-count-daily',

  GET_FEEDBACK_USERS: BASE_URL + '/sales/feedback-users',
  GET_FEEDBACK_USER_DETAILS: BASE_URL + '/sales/feedback-user-details',
  UPDATE_FEEDBACK_CALL_DETAILS: BASE_URL + '/sales/feedback-call-details',
};


export const DevConfigEndpoints = {
  ADD_CONFIG_DEV: BASE_URL_DEV + '/configs/addConfigValue',
  EDIT_CONFIG_DEV: BASE_URL_DEV + '/configs/updateConfig/',
  GET_ALL_CONFIG_DEV: BASE_URL_DEV + '/configs/getConfigDetails',
  DELETE_CONFIG_DEV: BASE_URL_DEV + '/configs/deleteConfig/',
};

